import React from "react";
import { observer, inject } from "mobx-react";
import { action, extendObservable } from "mobx";
import { injectIntl } from "react-intl";
import { Label, Panel, Collapse, Button } from "react-bootstrap";
import LabelsManagePanel from "./LabelsManagePanel";
import SelectableLabel from "./SelectableLabel";
// import {CAN_EDIT_LABEL} from "./authorization";

@injectIntl
@inject("rootStore")
@observer
export default class Labels extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    extendObservable(this, {
      showPanel: false
    });

    this.canEditLabel = props.rootStore.authorizationStore.canEditLabel;
    this.canToggleLabel = props.rootStore.authorizationStore.canToggleLabel(
      props.note
    );
  }

  render() {
    const { note, intl, rootStore } = this.props;

    return (
      <div className="note-labels-container">
        <Button
          onClick={this.toggleShowPanel}
          bsStyle="primary"
          block
          ref={element => (this.buttonRef = element)}
          style={{ marginBottom: "5px" }}
          disabled={!this.canToggleLabel}
        >
          {intl.formatMessage({ id: "add_tags" })}
        </Button>

        <div
          className="note-labels-label-container"
          onClick={this.toggleShowPanel}
        >
          {note.activeLabels.map((label, index) =>
            this.renderLabel(label, index)
          )}
        </div>

        <Collapse in={this.showPanel}>
          <Panel>
            {note.rootStore.valueProposition.labels.map((label, index) => (
              <SelectableLabel label={label} note={note} key={index} />
            ))}
            {this.canEditLabel && (
              <React.Fragment>
                <hr />
                <Button
                  onClick={this.toggleLabelModal}
                  block
                  style={{ marginBottom: "15px" }}
                >
                  {intl.formatMessage({ id: "manage" })}
                </Button>
              </React.Fragment>
            )}
          </Panel>
        </Collapse>

        <LabelsManagePanel note={note} />
      </div>
    );
  }

  renderLabel = (label, index) => {
    return (
      <Label
        className="note-labels-label"
        style={{ backgroundColor: label.color, marginRight: "5px" }}
        key={index}
      >
        {label.name}
      </Label>
    );
  };

  @action
  toggleShowPanel = () => {
    const { note } = this.props;

    // if there is no labels, show manage labels
    if (this.canEditLabel && !note.rootStore.valueProposition.labels.length) {
      note.toggleLabelsManagePanel();
    } else {
      this.showPanel = !this.showPanel;
      // close manage labels if it's opened
      if (note.showLabelManagePanel) {
        note.toggleLabelsManagePanel();
      }
    }
  };

  @action
  toggleLabelModal = () => {
    const { note } = this.props;

    this.toggleShowPanel();
    note.toggleLabelsManagePanel();
  };
}
